import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'getm-special-info',
  templateUrl: './special-info.component.html',
  styleUrls: ['./special-info.component.scss'],
})
export class SpecialInfoComponent {

  @Input() variant: 'counter' | 'button' = 'counter';
  @Input() iconName: string = 'getm-edit-outline';
  @Input() iconColor: string = 'getm-neutral-white';
  @Input() text: string = '';
  @Input() remainingTime: string | undefined;
  @Input() textColor: string = 'getm-neutral-white';
  @Input() buttonText: string = '';
  @Input() backgroundColor: string = 'getm-secondary-default';

  @Output() buttonClick = new EventEmitter<void>();

  public onButtonClick(): void {
    this.buttonClick.emit();
  }

}
